import React from 'react';
import { useWillMount } from '@beef/react';

import store from 'store';
import { pushViewedTariffCard } from 'utils/ga';
import { pushEcommerceTariffView } from 'utils/analytics/simOrderAnalytics';
import { tariffData } from 'pages/ProductCard/actions/servicesExtension';

import type { ITariffCardReactModel } from '../types';

export function withLegacy(WrappedComponent: React.ComponentType<ITariffCardReactModel>) {
  return (props: ITariffCardReactModel) => {
    useWillMount(() => {
      // @ts-expect-error SERVER_ENV is global process variable
      store.dispatch(SERVER_ENV ? tariffData.set(props.data) : tariffData.update(props.data));
    });

    React.useEffect(() => {
      const GAParams: Record<string, any> = {
        itemTitle: props.data.pageTitle,
        itemSoc: props.data.soc,
        itemMarketCode: props.data.marketCode,
        myTariff: undefined,
      };

      if (props.data.isAuthenticated) {
        GAParams.myTariff = `${+props.data.isConnected}`;
      }

      pushViewedTariffCard(GAParams);
      pushEcommerceTariffView(props.data);
    }, []);

    return <WrappedComponent {...props} />;
  };
}
